import React, { useState } from 'react';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

// Sirina kolone sa akcijama (small dugme 26px + 3px sa strane) - ista u svim
// tabelama.
export const ROW_ACTIONS_COLUMN_WIDTH = 32;

// Zajednicki "⋮" meni akcija za red tabele. Akcije podrzavaju per-row
// `visible` / `disabled` predikate i `label` kao funkciju reda.
//
// antd Dropdown se montira tek na prvi klik: tabela sa 100 redova inace
// renderuje 100 Dropdown-a unapred, sto primetno usporava listanje strana.
const RowActionsMenu = ({ actions, row }) => {
  const [dropdownMounted, setDropdownMounted] = useState(false);
  const [open, setOpen] = useState(false);

  const visibleActions = actions.filter((action) =>
    action.visible ? action.visible(row) : true
  );

  if (!visibleActions.length) return null;

  const button = (
    <Button
      type="text"
      size="small"
      aria-label="Opcije"
      icon={<MoreOutlined style={{ fontSize: 15 }} />}
      onClick={
        dropdownMounted
          ? undefined
          : () => {
              setDropdownMounted(true);
              setOpen(true);
            }
      }
    />
  );

  if (!dropdownMounted) return button;

  const items = visibleActions.map((action) => {
    // eslint-disable-next-line no-unused-vars
    const { visible, ...rest } = action;
    return {
      ...rest,
      label: typeof rest.label === 'function' ? rest.label(row) : rest.label,
      disabled:
        typeof rest.disabled === 'function'
          ? rest.disabled(row)
          : !!rest.disabled,
      onClick: () => {
        setOpen(false);
        rest.onClick(row);
      },
    };
  });

  return (
    <Dropdown
      menu={{ title: 'Opcije', items }}
      trigger={['click']}
      placement="bottomRight"
      open={open}
      onOpenChange={setOpen}
    >
      {button}
    </Dropdown>
  );
};

RowActionsMenu.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
      onClick: PropTypes.func.isRequired,
      visible: PropTypes.func,
      disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    })
  ).isRequired,
  row: PropTypes.object.isRequired,
};

export default RowActionsMenu;
